import React from 'react';

import './dragDrop.css';

/**
 * Component hiển thị drag preview (element theo chuột khi kéo)
 */
export const DragPreview = ({ dragPreview }) => {
  if (!dragPreview.show) return null;

  return (
    <div
      className="drag-preview"
      style={{
        left: dragPreview.x,
        top: dragPreview.y,
      }}
    >
      {dragPreview.content}
    </div>
  );
};

/**
 * Component hiển thị confirmation dialog cho drag & drop
 */
export const DragConfirmDialog = ({
  confirmDialog,
  onConfirm,
  onCancel
}) => {

  // Lấy dữ liệu sau khi Hook đã được gọi
  const {
    sourceRoom,
    targetRoom,
    sourceDate,
    targetDate,
    booking,
    validationMessage,
    isLoading
  } = confirmDialog || {};

  // Hook phải được gọi trước mọi conditional return
  const [dataChangeOther2, setDataChangeOther2] = React.useState(
    booking?.other2 || booking?.request2 ||''
  );

  React.useEffect(() => {
    // Khi confirmDialog thay đổi, cập nhật lại dataChangeOther2
    setDataChangeOther2(booking?.other2 || booking?.request2 || '');
  }, [booking]);

  // Nếu không hiển thị dialog thì return
  if (!confirmDialog?.show) return null;

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9999,
        }}
        onClick={onCancel}
      />

      {/* Dialog */}
      <div className="drag-confirm-dialog">

        <div className="drag-confirm-dialog-header">
          Move Booking Confirmation
        </div>

        <div className="drag-confirm-dialog-content">
          Are you sure you want to move this booking to a different room or date?
        </div>

        <div className="drag-confirm-dialog-detail">

          <div className="drag-confirm-dialog-detail-row">
            <span className="drag-confirm-dialog-detail-label">
              Guest Name:
            </span>

            <span className="drag-confirm-dialog-detail-value">
              {booking?.name}
            </span>
          </div>

          <div className="drag-confirm-dialog-detail-row">
            <span className="drag-confirm-dialog-detail-label">
              From Room:
            </span>

            <span className="drag-confirm-dialog-detail-value">
              {sourceRoom}
            </span>
          </div>

          <div className="drag-confirm-dialog-detail-row">
            <span className="drag-confirm-dialog-detail-label">
              To Room:
            </span>

            <span className="drag-confirm-dialog-detail-value">
              {targetRoom}
            </span>
          </div>

          <div className="drag-confirm-dialog-detail-row">
            <span className="drag-confirm-dialog-detail-label">
              From Date:
            </span>

            <span className="drag-confirm-dialog-detail-value">
              {formatDate(sourceDate)}
            </span>
          </div>

          <div className="drag-confirm-dialog-detail-row">
            <span className="drag-confirm-dialog-detail-label">
              To Date:
            </span>

            <span className="drag-confirm-dialog-detail-value">
              {formatDate(targetDate)}
            </span>
          </div>

          {booking?.nights && (
            <div className="drag-confirm-dialog-detail-row">
              <span className="drag-confirm-dialog-detail-label">
                Nights:
              </span>

              <span className="drag-confirm-dialog-detail-value">
                {booking.nights}
              </span>
            </div>
          )}

          <div className="drag-confirm-dialog-detail-row">
            <span className="drag-confirm-dialog-detail-label">
              Requirement2:
            </span>

            <textarea
              className="drag-confirm-dialog-detail-value"
              value={dataChangeOther2}
              onChange={(e) => setDataChangeOther2(e.target.value)}
              style={{
                width: '70%'
              }}
            />
          </div>

        </div>

        {validationMessage && (
          <div
            style={{
              backgroundColor: '#f0fdf4',
              border: '1px solid #22c55e',
              borderRadius: '6px',
              padding: '10px',
              marginBottom: '16px',
              fontSize: '13px',
              color: '#166534',
            }}
          >
            ✓ {validationMessage}
          </div>
        )}

        <div className="drag-confirm-dialog-buttons">

          <button
            className="drag-confirm-btn drag-confirm-btn-cancel"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancel
          </button>

          <button
            className="drag-confirm-btn drag-confirm-btn-confirm"
            onClick={() => onConfirm(dataChangeOther2, "drag_drop_reschedule")}
            disabled={isLoading}
          >
            {isLoading ? 'Processing...' : 'Confirm Move'}
          </button>

        </div>

      </div>
    </>
  );
};

/**
 * Component hiển thị drag status indicator
 */
export const DragStatusIndicator = ({
  status,
  message,
  duration = 3000
}) => {

  const [show, setShow] = React.useState(!!status);

  React.useEffect(() => {
    if (status) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
      }, duration);

      return () => clearTimeout(timer);
    }

  }, [status, duration]);

  if (!show) return null;

  return (
    <div className={`drag-status-indicator ${status}`}>
      {status === 'success' && '✓ '}
      {status === 'error' && '✗ '}
      {status === 'warning' && '⚠ '}
      {message}
    </div>
  );
};